import { Component } from '@angular/core';

@Component({
  selector: 'app-skill-legend',
  templateUrl: './skill-legend.component.html',
  styleUrls: ['./skill-legend.component.scss']
})
export class SkillLegendComponent { }
